import React from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import { LeadSentence, PageHeader } from '../components'

const ErrorPage: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Box>
      <PageHeader title='ページが見つかりません。' />

      <Grid container className='content-wrapper'>
        <Grid item xs={12} md={8} lg={6} className='content'>

          <LeadSentence>
            <>
              アクセスしようとしたページが見つかりませんでした。<br />
              アドレスが間違っているかページが移動・削除された可能性があります。
            </>
          </LeadSentence>

          {/* 閉じる */}
          <Box>
            <Grid container
              sx={{
                mt: 4,
                mb: 1,
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <Grid item xs={12} md={8} lg={8}>
                <Button
                  size='large'
                  variant='outlined'
                  fullWidth
                  onClick={() => { navigate('/') }}
                >
                  荷物問い合わせサービスに移動する
                </Button>
              </Grid>
            </Grid>
          </Box>

        </Grid>
      </Grid>

    </Box>
  )
}

export default ErrorPage
